import { AssignmentRuleAll, AssignmentRuleSingle, AssignmentRuleType, RiskProfile, RiskProfileInput } from '@evidentid/tprm-portal-lib/models/decisioning';
import { ComplianceStatusMetadata } from '@evidentid/tprm-portal-lib/models/entity-details';
import {
    EntityRequirementDetails,
} from '@evidentid/tprm-portal-lib/models/entity-details/EntityRequirement.model';

export type AssignmentRuleValue = string | number | boolean;

export interface BasicAssignmentRule {
    operator: string;
    insuredFieldKey: string;
    value: AssignmentRuleValue;
}

export interface FieldEvaluationResultErrorMessage {
    message: string;
    coverageCriteriaGroupName: string;
}

export interface FieldEvaluationResultError {
    evaluatedEntityId?: string;
    useDuringComplianceCalculation?: boolean;
    messages: FieldEvaluationResultErrorMessage[];
    coverageCriteriaGroupId: string;
    criterionId: string[];
    criterionNames: string[];
    coverageDetailsBelongTo: EntityRequirementDetails;
    complianceStatusMetadata: ComplianceStatusMetadata[];
    isMultiFieldCriterion: boolean;
}

export const requirementTypeFieldReferenceDelimiter = '-';

export enum GeneralAggregateLimitReferences {
    generalAggregateLimitThreshold = 'generalAggregateLimitThreshold',
    conditionSets = 'conditionSets',
}

export interface UiSelectedAssignmentRule {
    type: AssignmentRuleType.selected;
    expression: BasicAssignmentRule[][];
}

export type UiAssignmentRule = AssignmentRuleAll | UiSelectedAssignmentRule | AssignmentRuleSingle;

export interface UiRiskProfile extends Omit<RiskProfile, 'assignmentRule'> {
    assignmentRule: UiAssignmentRule | null;
}
export interface UiRiskProfileInput extends Omit<RiskProfileInput, 'assignmentRule'> {
    assignmentRule: UiAssignmentRule | null;
}
